/* eslint-disable react/no-multi-comp */

import React from 'react';
import { Form, Grid, Row, Col, InputGroup } from 'rsuite';
import EyeIcon from '@rsuite/icons/legacy/Eye';
import EyeSlashIcon from '@rsuite/icons/legacy/EyeSlash';
import { InfoPoint } from '../../components';
import CellPhoneParts from '../../asset/cellPhone.png';
import HelpOutlineIcon from '@rsuite/icons/HelpOutline';
import NumberFormat from 'react-number-format';
import { checkInputPhone } from '../';
import { usePhoneLength } from '../../hooks';

const cellPhoneCharacteristic = {
    height: '36px',
    display: 'flex',
    alignItems: 'center',
};

const infoPointContent = {
    width: '340px',
    fontSize: '11px',
};

const infoPointTitle = {
    fontSize: '12px',
    fontWeight: 'bold',
};

const helpIcon = {
    color: '#3699FF',
    marginLeft: 10,
    fontSize: '1.5em',
    cursor: 'pointer',
};

export const modalSize = {
    xs: 'xs',
    sm: 'sm',
    md: 'md',
    lg: 'lg',
    full: 'full',
};

export const errorPlacementData = {
    bottomStart: 'bottomStart',
    bottomEnd: 'bottomEnd',
    topStart: 'topStart',
    topEnd: 'topEnd',
    leftStart: 'leftStart',
    rightStart: 'rightStart',
    leftEnd: 'leftEnd',
    rightEnd: 'rightEnd'
};

//
// Form field standar
//
// eslint-disable-next-line react/display-name
export const TextField = React.forwardRef((props, ref) => {
    const { name, label, className, accepter, ...rest } = props;
    return (
        <div className={className || ''}>
            {/* <div className="col"> */}
            <Form.Group>
                <Form.ControlLabel name={label}>{label}</Form.ControlLabel>
                <Form.Control name={name} accepter={accepter} {...rest} />
            </Form.Group>
        </div>
    );
});

//
// Form field standar multifunction
//
// eslint-disable-next-line react/display-name
export const Field = React.forwardRef((props, ref) => {
    const { name, message, label, accepter, classNameGroup, showPassword, classNameLabel, error, ...rest } = props;
    return (
        <Form.Group controlId={`${name}-10`} ref={ref} className={error ? 'has-error' : classNameGroup}>
            <Form.ControlLabel className={classNameLabel}>{label} </Form.ControlLabel>
            <Form.Control name={name} accepter={accepter} errorMessage={getErrorMessage(error)} {...rest} />
            {/* <HelpBlock>{message}</HelpBlock> */}
            {/* <Form.HelpText>{message}</Form.HelpText> */}
        </Form.Group>
    );
});

// eslint-disable-next-line react/display-name
export const PasswordField = React.forwardRef((props, ref) => {
    const { name, message, label, accepter, classNameGroup, handleShowPassword, showPassword, className, classNameLabel, hasIcon, handleOnCopy, placeholder, ...rest } = props;
    return (
        <Form.Group controlId={`${name}-10`} ref={ref} className={classNameGroup}>
            <Form.ControlLabel className={classNameLabel}>{label} </Form.ControlLabel>
            <InputGroup inside className={className} onCopy={handleOnCopy}>
                <Form.Control
                    name={name}
                    placeholder={placeholder}
                    accepter={accepter}
                    type={showPassword ? 'text' : 'password'}
                    {...rest}
                />
                {hasIcon &&
                <InputGroup.Button onClick={handleShowPassword}>
                    {showPassword ? <EyeIcon /> : <EyeSlashIcon />}
                </InputGroup.Button>}
            </InputGroup>
        </Form.Group>
    );
});

/*
1 - Example of input number
<Field name="number" label="Number" accepter={InputNumber} error={formError.number} />

2 - Example of checkbox
<Field
    name="skills"
    label="Skills"
    accepter={CheckboxGroup}
    error={formError.skills}
    inline
>
    <Checkbox value={'Node.js'}>Node.js</Checkbox>
    <Checkbox value={'CSS3'}>CSS3</Checkbox>
    <Checkbox value={'Javascript'}>Javascript</Checkbox>
    <Checkbox value={'HTML5'}>HTML5</Checkbox>
</Field>;

3 - Example of RadioGroup
< Field
    name = "browser"
    label = "Browser"
    accepter = { RadioGroup }
    error = { formError.browser }
    inline
>
    <Radio value={'Chrome'}>Chrome</Radio>
    <Radio value={'FireFox'}>FireFox</Radio>
    <Radio value={'IE'}>IE</Radio>
</Field >;

4 - Example of CheckPicker
<Field
    name="status"
    label="Status"
    accepter={CheckPicker}
    error={formError.status}
    style={{ display: 'inline-block', width: 200 }}
    data={[
        { label: 'Todo', value: 'todo' },
        { label: 'Open', value: 'open' },
        { label: 'Close', value: 'close' },
        { label: 'Error', value: 'error' },
        { label: 'Processing', value: 'processing' },
        { label: 'Done', value: 'done' }
    ]}
/>;

5 - Example of Slider
<Field
    accepter={Slider}
    min={0}
    max={20}
    name="level"
    label="Level"
    style={{ width: 200, margin: '10px 0' }}
    errorMessage={formError.level}
/>;

6 - Example of DatePicker
<Field
    accepter={DatePicker}
    name="createDate"
    label="Create Date"
    errorMessage={formError.createDate}
/>;
*/

//
// Form field for cell phone
//
// eslint-disable-next-line react/display-name
export const CellPhoneField = React.forwardRef((props, ref) => {
    const { name, message, label, cellPhone, accepter, classNameGroup, classNameLabel, error, styleCellPhone, errorCellPhone, ...rest } = props;
    const maxLen = usePhoneLength(cellPhone);

    return (
        <Form.Group controlId={`${name}-10`} ref={ref} className={error ? 'has-error' : classNameGroup} onChange={() => checkInputPhone(name, ref.current.root)}>
            <Form.ControlLabel className={classNameLabel}>
                {label}
                <InfoPoint
                    placement="right"
                    content={
                        <div style={infoPointContent}>
                            <h6 style={infoPointTitle}>Para completar este campo tome en cuenta:</h6>
                            <p>Los números de teléfono tienen un total de diez dígitos, compuesto por:</p>
                            <ul>
                                <li>El código de área, este puede tener 2, 3 o 4 dígitos. No incluir el CERO.</li>
                                <li>El número de abonado, este se divide en dos partes:</li>
                                <ul>
                                    <li>La característica, con una longitud de 2,3 o 4 dígitos.</li>
                                    <li>El número, con una longitud de 4 dígitos.</li>
                                </ul>
                            </ul>
                            <img src={CellPhoneParts} alt="Cell phone parts" width={300} />
                        </div>
                    }
                >
                    <HelpOutlineIcon style={helpIcon} />
                </InfoPoint>
            </Form.ControlLabel>
            <Grid fluid>
                <Row className="show-grid">
                    <Col xs={7}>
                        <Form.Control maxLength={`${maxLen.code}`} name={`${name}AreaCode`} id={`${name}AreaCode`} accepter={accepter} errorMessage={getErrorMessage(errorCellPhone ? errorCellPhone.cellPhoneAreaCode : null)} value={cellPhone.code} style={styleCellPhone ? styleCellPhone.cellPhoneAreaCode : {}} {...rest} />
                    </Col>
                    <Col xs={2} style={cellPhoneCharacteristic}>
                        15
                    </Col>
                    <Col xs={7}>
                        <Form.Control
                            maxLength={`${maxLen.characteristic}`}
                            name={`${name}Characteristic`}
                            id={`${name}Characteristic`}
                            accepter={accepter}
                            errorMessage={getErrorMessage(errorCellPhone ? errorCellPhone.cellPhoneCharacteristic : null)}
                            value={cellPhone.characteristic}
                            style={styleCellPhone ? styleCellPhone.cellPhoneCharacteristic : {}}
                            {...rest}
                        />
                    </Col>
                    <Col xs={8}>
                        <Form.Control maxLength={`${maxLen.number}`} name={`${name}Number`} id={`${name}Number`} accepter={accepter} errorMessage={getErrorMessage(errorCellPhone ? errorCellPhone.cellPhoneNumber : null)} value={cellPhone.number} style={styleCellPhone ? styleCellPhone.cellPhoneNumber : {}} {...rest} />
                    </Col>
                </Row>
            </Grid>
            {/* <HelpBlock>{message}</HelpBlock> */}
            {/* <Form.HelpText>{message}</Form.HelpText> */}
        </Form.Group>
    );
});

//
// Form field for CVU/CBU or Alias
//
// eslint-disable-next-line react/display-name
export const CVUField = React.forwardRef((props, ref) => {
    const { name, message, label, cellPhone, accepter, classNameGroup, classNameLabel, error, ...rest } = props;

    return (
        <Form.Group controlId={`${name}-10`} ref={ref} className={error ? 'has-error' : classNameGroup}>
            <Form.ControlLabel className={classNameLabel}>
                {label}
                <InfoPoint
                    placement="right"
                    content={
                        <div style={infoPointContent}>
                            <h6 style={infoPointTitle}>Para completar este campo tome en cuenta:</h6>
                            <p>Debe ser una cuenta en pesos del mismo titular que la persona que solicita el préstamo.</p>
                        </div>
                    }
                >
                    <HelpOutlineIcon style={helpIcon} />
                </InfoPoint>
            </Form.ControlLabel>
            <Form.Control name={name} accepter={accepter} errorMessage={error} {...rest} />
        </Form.Group>
    );
});

//
// Form field for phone
//
// eslint-disable-next-line react/display-name
export const PhoneField = React.forwardRef((props, ref) => {
    const { name, message, label, phone, accepter, classNameGroup, classNameLabel, error, styleCellPhone, errorCellPhone, ...rest } = props;
    const maxLen = usePhoneLength(phone);

    return (
        <Form.Group controlId={`${name}-10`} ref={ref} className={error ? 'has-error' : classNameGroup} onChange={() => checkInputPhone(name, ref.current.root)}>
            <Form.ControlLabel className={classNameLabel}>
                {label}
                <InfoPoint
                    placement="right"
                    content={
                        <div style={infoPointContent}>
                            <h6 style={infoPointTitle}>Para completar este campo tome en cuenta:</h6>
                            <p>Los números de teléfono tienen un total de diez dígitos, compuesto por:</p>
                            <ul>
                                <li>El código de área, su longitud puede variar de 2 a 4 dígitos. No es necesario completar con cero.</li>
                                <li>El número de abonado, este se divide en dos partes:</li>
                                <ul>
                                    <li>La característica, comunmente de 3 o 4 dígitos. No es necesario completar con cero.</li>
                                    <li>El número, con una longitud de 4 dígitos.</li>
                                </ul>
                            </ul>
                            <img src={CellPhoneParts} alt="Phone parts" width={300} />
                        </div>
                    }
                >
                    <HelpOutlineIcon style={helpIcon} />
                </InfoPoint>
            </Form.ControlLabel>
            <Grid fluid>
                <Row className="show-grid">
                    <Col xs={8}>
                        <Form.Control maxLength={`${maxLen.code}`} name={`${name}AreaCode`} id={`${name}AreaCode`} accepter={accepter} errorMessage={getErrorMessage(errorCellPhone ? errorCellPhone.cellPhoneAreaCode : null)} value={phone.code} style={styleCellPhone ? styleCellPhone.cellPhoneAreaCode : {}} {...rest} />
                    </Col>
                    <Col xs={8}>
                        <Form.Control
                            maxLength={`${maxLen.characteristic}`}
                            name={`${name}Characteristic`}
                            id={`${name}Characteristic`}
                            accepter={accepter}
                            errorMessage={getErrorMessage(errorCellPhone ? errorCellPhone.cellPhoneCharacteristic : null)}
                            value={phone.characteristic}
                            style={styleCellPhone ? styleCellPhone.cellPhoneCharacteristic : {}}
                            {...rest}
                        />
                    </Col>
                    <Col xs={8}>
                        <Form.Control maxLength={`${maxLen.number}`} name={`${name}Number`} id={`${name}Number`} accepter={accepter} errorMessage={getErrorMessage(errorCellPhone ? errorCellPhone.cellPhoneNumber : null)} value={phone.number} style={styleCellPhone ? styleCellPhone.cellPhoneNumber : {}} {...rest} />
                    </Col>
                </Row>
            </Grid>
            {/* <HelpBlock>{message}</HelpBlock> */}
            {/* <Form.HelpText>{message}</Form.HelpText> */}
        </Form.Group>
    );
});

//
// Form field for currency
//
// eslint-disable-next-line react/display-name
export const CurrencyField = React.forwardRef(({ onChange, ...rest }, ref) => (
    <NumberFormat
        {...rest}
        ref={ref}
        className="rs-input"
        thousandSeparator="."
        decimalSeparator=","
        prefix={'$'}
        onValueChange={values => {
            onChange(values.floatValue);
        }}
    />
));

//
// Auxiliary Functions
//

const getErrorMessage = (msg) => {
    return msg?.length ? <span><i className="fa fa-info-circle text-primary" /> {msg}</span> : undefined;
};
